import { Modelo } from '@ext/index';
import * as Types from './Articulo.types';
import moment, { Moment } from 'moment';

export class IArticulo extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: string = '';
    public Descripcion: string = '';
    public Clasificacion: string = '';
    public CantidadPorEtiquetas: number = 0;
    public PesoTotal: number = 0;
    public PesoNeto: number = 0;
    public CantidadUnidad: number = 0;
    public Unidad: string = '';
    public Reemplazo: string = '';
    public CodigoProveedor: string = '';
    public FechaAlta: Moment = moment( '' );
    public FechaUltimoIngreso: Moment = moment( '' );
    public UltimoCosto: number = 0;
    public FechaUltimaVenta: Moment = moment( '' );
    public CondicionIva: string = '';
    public Piso: string = '';
    public Cola: string = '';
    public LineaId: number = 0;
    public SectorId: number = 0;
    public TituloId: number = 0;
    public MarcaId: number = 0;
    public MarcaAlternativaId: number = 0;
    public Imagen: string = '';


    public getJson(): any {
        let json: any = {};

        json.id = this.Id;
        json.descripcion = this.Descripcion;
        json.clasificacion = this.Clasificacion;
        json.cantidad_por_etiquetas = this.CantidadPorEtiquetas;
        json.peso_total = this.PesoTotal;
        json.peso_neto = this.PesoNeto;
        json.cantidad_unidad = this.CantidadUnidad;
        json.unidad = this.Unidad;
        json.reemplazo = this.Reemplazo;
        json.codigo_proveedor = this.CodigoProveedor;
        json.fecha_alta = this.FechaAlta.toSQL();
        json.fecha_ultimo_ingreso = this.FechaUltimoIngreso.toSQL();
        json.ultimo_costo = this.UltimoCosto;
        json.fecha_ultima_venta = this.FechaUltimaVenta.toSQL();
        json.condicion_iva = this.CondicionIva;
        json.piso = this.Piso;
        json.cola = this.Cola;
        json.linea_id = this.LineaId;
        json.sector_id = this.SectorId;
        json.titulo_id = this.TituloId;
        json.marca_id = this.MarcaId;
        json.marca_alternativa_id = this.MarcaAlternativaId;


        return json;
    }


    public set(): boolean {

        this.Id = !this.Json.id ? '' : this.Json.id;
        this.Descripcion = !this.Json.descripcion ? '' : this.Json.descripcion;
        this.Clasificacion = !this.Json.clasificacion ? '' : this.Json.clasificacion;
        this.CantidadPorEtiquetas = !this.Json.cantidad_por_etiquetas ? 0 : this.Json.cantidad_por_etiquetas;
        this.PesoTotal = !this.Json.peso_total ? 0 : this.Json.peso_total;
        this.PesoNeto = !this.Json.peso_neto ? 0 : this.Json.peso_neto;
        this.CantidadUnidad = !this.Json.cantidad_unidad ? 0 : this.Json.cantidad_unidad;
        this.Unidad = !this.Json.unidad ? '' : this.Json.unidad;
        this.Reemplazo = !this.Json.reemplazo ? '' : this.Json.reemplazo;
        this.CodigoProveedor = !this.Json.codigo_proveedor ? '' : this.Json.codigo_proveedor;
        this.FechaAlta = !this.Json.fecha_alta ? moment( '' ) : moment( this.Json.fecha_alta );
        this.FechaUltimoIngreso = !this.Json.fecha_ultimo_ingreso ? moment( '' ) : moment( this.Json.fecha_ultimo_ingreso );
        this.UltimoCosto = !this.Json.ultimo_costo ? 0 : this.Json.ultimo_costo;
        this.FechaUltimaVenta = !this.Json.fecha_ultima_venta ? moment( '' ) : moment( this.Json.fecha_ultima_venta );
        this.CondicionIva = !this.Json.condicion_iva ? '' : this.Json.condicion_iva;
        this.Piso = !this.Json.piso ? '' : this.Json.piso;
        this.Cola = !this.Json.cola ? '' : this.Json.cola;
        this.LineaId = !this.Json.linea_id ? 0 : this.Json.linea_id;
        this.SectorId = !this.Json.sector_id ? 0 : this.Json.sector_id;
        this.TituloId = !this.Json.titulo_id ? 0 : this.Json.titulo_id;
        this.MarcaId = !this.Json.marca_id ? 0 : this.Json.marca_id;
        this.MarcaAlternativaId = !this.Json.marca_alternativa_id ? 0 : this.Json.marca_alternativa_id;
        this.Imagen = !this.Json.imagen ? '' : this.Json.imagen;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: IArticulo ) {
        this.Model = Model;
    }

    public Model: IArticulo;
}